export const APP_STORE =
  'https://itunes.apple.com/ru/app/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%B5%D1%81%D0%BA%D0%B0-%D1%80%D1%83/id500480133?mt=8';
export const GOOGLE_PLAY =
  'https://play.google.com/store/apps/details?id=com.rndelikateska';
export const HUAWEI_STORE =
  'https://appgallery.cloud.huawei.com/ag/n/app/C107115409?locale=ru_RU&source';
export const RUSTORE = 'https://www.rustore.ru/catalog/app/com.rndelikateska';

const getLocalIP = (): string => {
  if (typeof window !== 'undefined') {
    const hostname = location.hostname;
    const port = location.port;

    if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
      return `http://${hostname}:${port}`;
    }
  }

  return 'http://192.168.0.136:8080';
};

const isDevelopment = process.env.NODE_ENV === 'development';
const localDevUrl = `${getLocalIP()}/app-download`;
const productionUrl = 'https://delikateska.ru/app-download';

export const SMART_APP_LINK = isDevelopment ? localDevUrl : productionUrl;
